/**
 * Quote Rejection Modal
 * Handles quote rejection with optional reason
 */

import React, { useState } from "react";
import { Modal, Form, Input, Button, Space, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { markQuoteRejected } from "../services/quoteActionService";

const { TextArea } = Input;

const QuoteRejectionModal = ({
  visible,
  quote,
  onClose,
  onSuccess,
  userId,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const result = await markQuoteRejected(quote.id, {
        reason: values.reason || "",
        adminId: userId,
      });

      if (result.success) {
        message.success("Quote marked as rejected successfully");
        form.resetFields();
        if (onSuccess) {
          onSuccess(result.data);
        }
        onClose();
      } else {
        message.error(result.error || "Failed to mark quote as rejected");
      }
    } catch (error) {
      console.error("Error rejecting quote:", error);
      message.error("Failed to reject quote. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
          <span>Mark Quote as Rejected</span>
        </Space>
      }
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnHidden
      maskClosable={!loading}
    >
      <div style={{ marginBottom: 16 }}>
        <span style={{ color: "#ff4d4f" }}>⚠️</span>{" "}
        <span>This action cannot be undone.</span>
      </div>

      <div style={{ marginBottom: 16 }}>
        <strong>Quote ID:</strong> {quote.id}
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="reason" label="Reason for Rejection (Optional)">
          <TextArea
            rows={4}
            placeholder="Explain why this quote is being rejected..."
          />
        </Form.Item>

        <div style={{ textAlign: "right", marginTop: 24 }}>
          <Space>
            <Button onClick={handleCancel} disabled={loading}>
              Cancel
            </Button>
            <Button
              type="primary"
              danger
              htmlType="submit"
              loading={loading}
              icon={<CloseCircleOutlined />}
            >
              Mark as Rejected
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

export default QuoteRejectionModal;
